import React from "react";

import { AlarmPageStrings, DELETE_DIALOG_STRINGS, TagPageStrings } from "constants/constantStrings";

import DupontDialog from "components/DupontDialog";

function DeleteTagAlarmModal(props) {
  const { deleteRow } = props;
  const { isDeleteAlarm } = props;
  return (
    <>
      <DupontDialog
        open
        type="primary"
        title={`${DELETE_DIALOG_STRINGS.delete.replace("[%]", isDeleteAlarm ? AlarmPageStrings.theAlarm : TagPageStrings.theTag)} ${
          isDeleteAlarm ? deleteRow.AlarmID : deleteRow.TagId
        }?`}
        cancelBtnText={DELETE_DIALOG_STRINGS.actionNo}
        confirmBtnText={DELETE_DIALOG_STRINGS.actionYes}
        onClose={props.onDeleteDlgClose}
      >
        {DELETE_DIALOG_STRINGS.action}
      </DupontDialog>
    </>
  );
}

export default DeleteTagAlarmModal;
